
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    visibleDesktopNavigation: {
      type: String,
      required: true,
    },
  },
  emits: ['hide-navigation'],
  setup(_props, { emit }) {
    const hideNavi = () => {
      emit('hide-navigation', '')
    }

    return { hideNavi }
  },
})
